import { InstreamAd } from '@/app_components/common/ads/InStream';
import type { ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { baseAdPlacementConfig } from '@/app_lib/utils/ads';

interface EmbedAdSlotsProps {
  frequency: number;
}

export const embedAdSlots = ({ frequency }: EmbedAdSlotsProps): ParserRule => ({
  insertComponent: ({ index }) => {
    if (!frequency) {
      return <></>;
    }
    const adIndex = Math.max(0, Math.ceil(index / frequency) - 1); // 0 indexed
    return (
      <div
        className='py-4 min-h-[250px] box-content'
        key={`ad-embed-${adIndex}`}
      >
        <InstreamAd
          className='min-h-[250px] flex items-center'
          dataCy={ContentPlacement.InContent}
          index={adIndex}
          placementName='InContent'
        />
      </div>
    );
  },
  insertPosition: 'after',
  match: ({ nodeTracker, node }) =>
    Boolean(frequency) && node.type === 'p' && nodeTracker.p % frequency === baseAdPlacementConfig.firstAdPlacement,
});
